// @flow
import * as React from 'react';
import classNames from 'classnames';
import Icon from '../Icon';

import './styles.scss';

type Props = {
  checked: ?boolean,
  onCheck: (boolean) => void,
  label: string,
  className?: string,
  classNameLabel?: string,
  disabled?: ?boolean,
  type?: string,
}

export default ({
  className,
  classNameLabel,
  checked,
  onCheck,
  label,
  disabled,
  type = 'default',
}: Props) => {
  const checkboxClass = classNames(
    'Checkbox',
    { Checkbox_disabled: disabled },
    className,
  );
  const squareClass = classNames('Checkbox-Square', { 'Checkbox-Square_checked': checked });
  const squareClassCircular = classNames('Checkbox-Circular', { 'Checkbox-Circular_checked': checked });
  const squareClassSquareNew = classNames('Checkbox-SquareNew', { 'Checkbox-SquareNew_checked': checked });

  const onCheckType = () => {
    if (type === 'circular') return squareClassCircular;
    if (type === 'square') return squareClassSquareNew;
    return squareClass;
  };

  const labelClass = classNames('Checkbox-Label', { 'Checkbox-Label_checked': checked });
  return (
    <button
      type="button"
      className={checkboxClass}
      onClick={() => (disabled ? null : onCheck(!checked))}
    >
      <div className={onCheckType()}>
        {checked && type === 'default' ? <Icon icon="check" /> : null}
        {checked && type === 'circular' ? <div className="Checkbox-СheckMarkCircular" /> : null}
        {checked && type === 'square' ? <Icon icon="check" /> : null}
      </div>
      <span className={classNames(labelClass, classNameLabel)}>
        {label}
      </span>
    </button>
  );
};
